module.exports = __webpack_public_path__ + "static/media/icon-alert.ec693fc5.svg";